import React, { useState, useEffect } from 'react';

function NotEkleModal({ isOpen, onClose, onSave, siparis }) {
    const [not, setNot] = useState('');

    useEffect(() => {
        // Modal açıldığında ve bir sipariş seçildiğinde,
        // o siparişin notlarını form alanına doldur.
        if (isOpen && siparis) {
            setNot(siparis.notlar || siparis.siparis_notu || '');
        }
    }, [isOpen, siparis]);

    if (!isOpen || !siparis) {
        return null;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        // Kaydetme işlemini ana bileşene (EftTakibi.js) bildir
        onSave(siparis.id, not);
    };

    // --- Stil Tanımlamaları ---
    const modalOverlayStyle = { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 };
    const modalContentStyle = { background: '#F8F8F8', padding: '30px', borderRadius: '8px', boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)', border: '1px solid #C2C2C2', width: '500px', fontFamily: 'Poppins, sans-serif' };
    const textareaStyle = { width: '100%', minHeight: '150px', padding: '10px', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'inherit', fontSize: '14px', resize: 'vertical' };
    const buttonStyle = { padding: '10px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold' };

    return (
        <div style={modalOverlayStyle} onClick={onClose}>
            <div style={modalContentStyle} onClick={e => e.stopPropagation()}>
                <form onSubmit={handleSubmit}>
                    <h2 style={{ marginTop: 0 }}>{siparis.ad_soyad} için Not Ekle/Düzenle</h2>
                    <textarea
                        value={not}
                        onChange={(e) => setNot(e.target.value)}
                        style={textareaStyle}
                        placeholder="Sipariş ile ilgili notlarınızı buraya yazın..."
                    />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '20px' }}>
                        <button type="button" onClick={onClose} style={{ ...buttonStyle, background: '#e2e2e2' }}>Vazgeç</button>
                        <button type="submit" style={{ ...buttonStyle, background: '#27ae60', color: 'white' }}>Notu Kaydet</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NotEkleModal;